<template>
  <div class="memberPie" ref="echarts"></div>
</template>

<script>
import { EchatsMixin } from '@/utils/echarts';
export default {
  mixins: [EchatsMixin],
  name: 'flowBar',
  data() {
    return {};
  },
  props: ['toilet'],
  computed: {},
  watch: {
    toilet: {
      handler(n) {
        if (n) {
          this.echarts_satisfied(n);
        }
      },
      deep: true
    }
  },
  methods: {
    // 满意度echarts
    echarts_satisfied(data) {
      let myChart = this.resizeEcharts();
      let option = {
        color: ["#1FD6E8"],
        grid: {
          top: 10,
          left: 0,
          right: 0,
          bottom: 0,
          containLabel: true,
        },
        tooltip: {
          trigger: "axis",
          axisPointer: {
            // 坐标轴指示器，坐标轴触发有效
            type: "shadow", // 默认为直线，可选为：'line' | 'shadow'
          },
        },
        xAxis: [
          {
            type: "category",
            data: data.day,
            axisTick: {
              alignWithLabel: true,
            },
            axisLabel: {
              show: true,
              textStyle: {
                color: "#fff",
              },
            },
          },
        ],
        yAxis: [
          {
            splitNumber: 3,
            type: "value",
            axisLabel: {
              show: true,
              textStyle: {
                color: "#fff",
              },
            },
          },
        ],
        series: [
          {
            name: "排水量",
            type: "line",
            barWidth: "60%",
            data: data.list,
          },
        ],
      };
      this.autoMatic(myChart, option.series[0].data.length);
      myChart.clear();
      myChart.setOption(option, true);
    }
  },
  mounted() {}
};
</script>

<style scoped>
.memberPie {
  width: 100%;
  height: 100%;
}
</style>



// WEBPACK FOOTER //
// src/components/html/flowBar.vue